import { render, staticRenderFns } from "./gofullscreenmodal.vue?vue&type=template&id=56ee5e45&scoped=true"
import script from "./gofullscreenmodal.vue?vue&type=script&lang=js"
export * from "./gofullscreenmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee5e45",
  null
  
)

export default component.exports